import { Grid } from "@mui/material";
import React from "react";
import { COUNTRIES_LIST, STATE_LIST } from "../../../../../../constants";
import CustomSelect from "../../../../../CustomSelect";
import Input from "../../../../../Input";
interface EmployerInfoProps {
  ind: number;
  formik: any; // Replace 'any' with the specific type of your formik object if available
}

const EmployerInfo: React.FC<EmployerInfoProps> = ({ formik, ind }) => {
  const { values, handleChange, handleBlur, setFieldValue, touched, errors } =
    formik;
  return (
    <Grid container spacing={3} xs={12} mt={0.2}>
      <Grid item xs={12}>
        <Input
          label="Employer Name"
          textFieldProps={{
            name: `patientInsurances[${ind}].employerName`,
            value: values.patientInsurances?.[ind]?.employerName,
            onChange: handleChange,
            onBlur: handleBlur,
            // placeholder: "Employer Name",
          }}
        />
      </Grid>
      {/* <Grid item xs={12}>
        <Typography fontWeight={500}>Employer Address</Typography>
      </Grid> */}
      <Grid item xs={6}>
        <Input
          label="Address Line 1"
          textFieldProps={{
            name: `patientInsurances[${ind}].employerAddress.line1`,
            value: values.patientInsurances?.[ind]?.employerAddress?.line1,
            onChange: handleChange,
            onBlur: handleBlur,
            // placeholder: "Enter Address Line 1",
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <Input
          label="Address Line 2"
          textFieldProps={{
            name: `patientInsurances[${ind}].employerAddress.line2`,
            value: values.patientInsurances?.[ind]?.employerAddress?.line2,
            onChange: handleChange,
            onBlur: handleBlur,
            // placeholder: "Enter Address Line 2",
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <Input
          label="City"
          textFieldProps={{
            name: `patientInsurances[${ind}].employerAddress.city`,
            value: values.patientInsurances?.[ind]?.employerAddress?.city,
            onChange: handleChange,
            onBlur: handleBlur,
            // placeholder: "Enter City",
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <CustomSelect
          label="State"
          value={values.patientInsurances?.[ind]?.employerAddress?.state}
          options={STATE_LIST}
          onChange={(value) =>
            setFieldValue(
              `patientInsurances[${ind}].employerAddress.state`,
              value
            )
          }
          // placeholder="Select State"
        />
      </Grid>
      <Grid item xs={3}>
        <CustomSelect
          value={values.patientInsurances?.[ind]?.employerAddress?.country}
          disableSortOptions
          options={COUNTRIES_LIST}
          onChange={(value) =>
            setFieldValue(
              `patientInsurances[${ind}].employerAddress.country`,
              value
            )
          }
          label="Country"
          // placeholder="Select Country"
        />
      </Grid>
      <Grid item xs={3}>
        <Input
          label="ZIP Code"
          textFieldProps={{
            name: `patientInsurances[${ind}].employerAddress.zipcode`,
            value: (() => {
              const d = (
                values.patientInsurances?.[ind]?.employerAddress?.zipcode || ""
              )
                .replace(/\D/g, "")
                .slice(0, 9);
              return d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d;
            })(),
            onChange: (e) => {
              const digits = e.target.value.replace(/\D/g, "").slice(0, 9);
              const val =
                digits.length > 5
                  ? `${digits.slice(0, 5)}-${digits.slice(5)}`
                  : digits;
              setFieldValue(
                `patientInsurances[${ind}].employerAddress.zipcode`,
                val
              );
            },
            onBlur: handleBlur,
            inputProps: { maxLength: 10 },
          }}
          error={
            (touched as any)?.patientInsurances?.[ind]?.employerAddress
              ?.zipcode &&
            (errors as any)?.patientInsurances?.[ind]?.employerAddress?.zipcode
          }
        />
      </Grid>
    </Grid>
  );
};

export default EmployerInfo;
